import { render, staticRenderFns } from "./BusquedaTramitesCardComponent.vue?vue&type=template&id=06b847c0&scoped=true"
import script from "./BusquedaTramitesCardComponent.vue?vue&type=script&lang=ts"
export * from "./BusquedaTramitesCardComponent.vue?vue&type=script&lang=ts"
import style0 from "./BusquedaTramitesCardComponent.vue?vue&type=style&index=0&id=06b847c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b847c0",
  null
  
)

export default component.exports